<template>
    <a :href="url" class="rounded-button" v-html="title"></a>
</template>

<script>
    export default {
        name: 'RoundedButton',

        props: {
            url:   { type: String, required: true },
            title: { type: String, required: true },
        },
    };
</script>

<style lang="scss">
    // See src/assets/styles/components/rounded-button.scss
</style>
